import { useParams } from 'react-router-dom';
import CatalogView from '@/pages/category/components/CatalogView';

export default function CategoryListPage() {
  const { type } = useParams<{ type: string }>();
  return <CatalogView typeParam={type || 'movie'} mode="loadmore" />;
}